<template>
    <div class="m">
      <span class="newsBtn">{{text}}</span>
    </div>
</template>

<script>
    export default {
        name: "btn",
      props:['text']
    }
</script>

<style scoped>
  .newsBtn{
    background-color: #FAFAFA;
    color:black;
    font-weight: bold;
    padding: 10px 60px;
    cursor: pointer;
    position: relative;
    transition: all 2s;
    display: inline-block;
  }
  .newsBtn::before{
    content:'';
    display: inline-block;
    width:0;
    height:2px;
    background-color:rgba(201, 56, 44, 1);
    position: absolute;
    bottom: 0;
    left: 0;
    transition: width 2s;
  }
  .newsBtn:hover {
    color:rgba(201, 56, 44, 1);
  }
  .newsBtn:hover::before{
    width:100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/btn.vue